import React, { useState } from "react";
import { FaFilePdf } from "react-icons/fa";
import { pyqsData } from "../../data/staticData";

export default function GsPyqs() {
  const [yearGS, setYearGS] = useState("2023");
  const [yearCSAT, setYearCSAT] = useState("2023");
  const [activePdf, setActivePdf] = useState(null);
  const [currentPageGS, setCurrentPageGS] = useState(1);
  const [currentPageCSAT, setCurrentPageCSAT] = useState(1);
  const entriesPerPage = 5;

  const gsPyqs = {};
  const csatPyqs = {};
  pyqsData.forEach((item) => {
    if (item.subject.toLowerCase() === "gs") {
      if (!gsPyqs[item.year]) gsPyqs[item.year] = [];
      gsPyqs[item.year].push({
        name: item.title,
        file: item.filePath,
      });
    } else if (item.subject.toLowerCase() === "csat") {
      if (!csatPyqs[item.year]) csatPyqs[item.year] = [];
      csatPyqs[item.year].push({
        name: item.title,
        file: item.filePath,
      });
    }
  });

  const paginate = (items, page) => {
    const start = (page - 1) * entriesPerPage;
    const end = start + entriesPerPage;
    return items?.slice(start, end) || [];
  };

  const handleViewPdf = (pdfUrl) => {
    if (pdfUrl) {
      setActivePdf(pdfUrl);
    } else {
      alert("PDF not available.");
    }
  };

  return (
    <section id="prelims" className="w-full bg-gray-50 py-12 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto space-y-10">
        <h2 className="text-2xl md:text-3xl text-left font-bold text-blue-900 mb-6">
          Preliminary Examination PYQs
        </h2>

        {/* GS Section */}
        <div className="bg-white shadow-md rounded-lg p-6 relative border-l-8 border-blue-800">
          <div className="absolute top-4 right-4">
            <select
              value={yearGS}
              onChange={(e) => {
                setYearGS(e.target.value);
                setCurrentPageGS(1);
              }}
              className="border border-blue-800 text-blue-900 rounded-md px-2 py-1 focus:outline-none"
            >
              {Object.keys(gsPyqs).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <h3 className="text-lg font-bold text-blue-800 mb-4">
            General Studies (Prelims)
          </h3>

          {!gsPyqs[yearGS]?.length && (
            <div className="text-center py-6 text-gray-500">No PYQs found.</div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {paginate(gsPyqs[yearGS], currentPageGS).map((doc, idx) => (
              <button
                key={idx}
                onClick={() => handleViewPdf(doc.file)}
                className="flex items-center p-4 border rounded-lg shadow-sm bg-gray-50 hover:bg-gray-100 transition w-full"
              >
                <FaFilePdf className="text-blue-600 text-2xl mr-3 flex-shrink-0" />
                <span className="font-medium text-gray-800 truncate">
                  {doc.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* CSAT Section */}
        <div className="bg-white shadow-md rounded-lg p-6 relative border-l-8 border-red-700">
          <div className="absolute top-4 right-4">
            <select
              value={yearCSAT}
              onChange={(e) => {
                setYearCSAT(e.target.value);
                setCurrentPageCSAT(1);
              }}
              className="border border-red-700 text-red-900 rounded-md px-2 py-1 focus:outline-none"
            >
              {Object.keys(csatPyqs).map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
          <h3 className="text-lg font-bold text-red-800 mb-4">
            CSAT (Prelims)
          </h3>

          {!csatPyqs[yearCSAT]?.length && (
            <div className="text-center py-6 text-gray-500">No PYQs found.</div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {paginate(csatPyqs[yearCSAT], currentPageCSAT).map((doc, idx) => (
              <button
                key={idx}
                onClick={() => handleViewPdf(doc.file)}
                className="flex items-center p-4 border rounded-lg shadow-sm bg-gray-50 hover:bg-gray-100 transition w-full"
              >
                <FaFilePdf className="text-red-600 text-2xl mr-3 flex-shrink-0" />
                <span className="font-medium text-gray-800 truncate">
                  {doc.name}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* PDF Modal */}
        {activePdf && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-95 flex justify-center items-center p-2">
            <div className="absolute top-4 right-4">
              <button
                className="text-white text-3xl font-bold hover:text-red-500"
                onClick={() => setActivePdf(null)}
              >
                &times;
              </button>
            </div>
            <iframe
              src={activePdf}
              className="w-full h-full sm:h-[95vh] border-none"
              title="PDF Viewer"
            />
          </div>
        )}
      </div>
    </section>
  );
}
